import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';

class SubmittedHistoryGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.submittedHistoryGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: "single",
    };
  }

  getRowNodeId = data => {
    return data.guid;
  };

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var submittedQuestionnaireHistoryList = rowNodeArray.map(rowNode => rowNode.data);

    this.props.selectSubmittedQuestionnaireHistory(submittedQuestionnaireHistoryList);
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  };

  render() {
    const {
      // Load Submitted Questionnaire History
      loadSubmittedQuestionnaireHistoryActionStatus,
      submittedQuestionnaireHistoryArray,
      className = 'grid-wrapper',
    } = this.props;

    const isLoading = loadSubmittedQuestionnaireHistoryActionStatus === ACTION_STATUS.LOGINING;
    if (loadSubmittedQuestionnaireHistoryActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadSubmittedQuestionnaireHistoryActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={submittedQuestionnaireHistoryArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            getRowNodeId={this.getRowNodeId}
            frameworkComponents={this.state.frameworkComponents}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default SubmittedHistoryGrid;